import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  message,
} from "antd";
import {
  useCreatePermissionMutation,
  useGetRoleFucntionsQuery,
  useUpdatePermissionMutation,
} from "../graphql/generated/hooks";
import { useForm } from "antd/es/form/Form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import RobinPage from "../components/RobinPage";
import { useEffect, useState } from "react";

function PermissionMutate() {
  const { t, i18n } = useTranslation();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [editMode, setEditMode] = useState<boolean>(false);
  const [ready, setReady] = useState<boolean>(false);

  const [selectedRole, setSelectedRole] = useState<string | undefined>(
    location.state?.permission.role
  );

  const [createPermission, { loading: creating }] =
    useCreatePermissionMutation();
  const [updatePermission] = useUpdatePermissionMutation();
  const { data: roleFunctions, loading: loadingRoleFunctions } =
    useGetRoleFucntionsQuery();

  useEffect(() => {
    if (params.id) {
      if (+params.id === location.state?.permission?.id) {
        setEditMode(true);
        setReady(true);
      } else {
        navigate(-1);
      }
    } else setReady(true);
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values: any) => {
    if (editMode)
      await updatePermission({
        variables: {
          id: location.state.permission.id,
          name: values.name,
          role: values.role,
          functions: values.functions,
        },
      })
        .then(() => {
          messageApi.success(t("message.success.data_updated"));
          navigate(-1);
        })
        .catch((error) => {
          messageApi.error(t("message.error.data_update_failed"));
          console.error(error);
        });
    else
      await createPermission({
        variables: {
          name: values.name,
          role: values.role,
          functions: values.functions,
        },
      })
        .then(() => {
          messageApi.success(t("message.success.data_created"));
          navigate(-1);
        })
        .catch((error) => {
          messageApi.error(t("message.error.data_create_failed"));
          console.error(error);
        });
  };

  return (
    <RobinPage
      title={editMode ? t("title.edit_permission") : t("title.add_permission")}
    >
      <Row>
        {contextHolder}
        <Col span={24}>
          {ready ? (
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              dir={i18n.dir()}
              name="mutatePermission"
              initialValues={
                editMode
                  ? {
                      ...location.state.permission,
                    }
                  : undefined
              }
            >
              <Form.Item name="name" label="Name" required>
                <Input />
              </Form.Item>
              <Form.Item name="role" label="Role" required>
                <Select
                  loading={loadingRoleFunctions}
                  onChange={(value) => {
                    setSelectedRole(value);
                    form.setFieldValue("functions", []);
                  }}
                >
                  {roleFunctions?.getRoleFucntions?.map((roleFunction) => (
                    <Select.Option
                      key={roleFunction.role}
                      value={roleFunction.role}
                    >
                      {roleFunction.role}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="functions" label="Functions" required>
                <Select mode="multiple" loading={loadingRoleFunctions}>
                  {roleFunctions?.getRoleFucntions
                    ?.find(
                      (roleFucntions) => roleFucntions.role === selectedRole
                    )
                    ?.functions.map((fucntion) => (
                      <Select.Option key={fucntion} value={fucntion}>
                        {fucntion}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item>
                <Space>
                  <Button
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    {t("button.cancel")}
                  </Button>
                  <Button loading={creating} type="primary" htmlType="submit">
                    {t("button.save")}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          ) : (
            <Spin />
          )}
        </Col>
      </Row>
    </RobinPage>
  );
}

export default PermissionMutate;
